// extracted by mini-css-extract-plugin
export default {"empty_document_icon":"EmptyDocumentIcon_empty_document_icon__lNo3I"};